import type { FeaturePolicy } from '../types';
import { apiFetch } from './api';
import type { FeatureAccessDto } from './feature-access';

export async function fetchFeaturePolicy(): Promise<FeaturePolicy> {
  const res = await apiFetch<FeatureAccessDto>('/api/settings/feature-access');
  return res.policy;
}

export async function updateFeaturePolicy(policy: FeaturePolicy): Promise<FeaturePolicy> {
  const res = await apiFetch<FeatureAccessDto>('/api/settings/feature-access', {
    method: 'PUT',
    body: JSON.stringify({ policy }),
  });
  return res.policy;
}
